module.exports = {
    server: process.env.NODE_ENV === 'production'
        ? 'https://autotouch.net'
        : 'https://autotouch.net'
        // : 'http://192.168.2.213:8080'
}